<div id="iframe-portalV1">
  <div class="container-fluid">
    <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
      <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
        <ol class="breadcrumb ol-sf-1">
          <li class="breadcrumb-item">
            <a routerLink="/">Home</a>
          </li>
          <li aria-current="page" class="breadcrumb-item active">
            Hosting - Datacenter work visits history
          </li>
        </ol>
      </nav>
    </nav>
  </div>
  <div class="layout-main">
    <div class="container-fluid">

      <div class="symbols-title-row">
        <h3 class="mb-0"><b>Hosting - Datacenter work visit history</b></h3>
        <div *ngIf="isMckayUser" class="company-picker">
          <span class="company-picker-label">Account</span>
          <p-dropdown (onChange)="changeClient()" [(ngModel)]="selectedClientUniqid"
                      [filter]="true"
                      [options]="listClientsForClientDropDown"
                      [showClear]="true"
                      placeholder="Choose an account"></p-dropdown>
        </div>
      </div>

      <div *ngIf="showTables()">
        <div *ngIf="error" class="alert alert-warning alert-dismissible fade show">
          {{ errorMessage }}
          <button (click)="error = false" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="symbols-market-table">
          <p-table #dt (sortFunction)="customSort($event)" [columns]="cols"
                   [customSort]="true" [rowHover]="true"
                   [tableStyle]="{'table-layout':'auto'}" [value]="assignments">
            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of cols"
                    [pSortableColumnDisabled]="!col.sortable" [pSortableColumn]="col.field">
                  {{ col.header }}
                  <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template let-assignment pTemplate="body">
              <tr>
                <td>
                  <a class="cabinet-link" [routerLink]="'/assignment/' + assignment.id">{{ assignment.cabinet.name }}</a>
                  <span *ngIf="assignment.cabinet.hasAlert" class="power-cap-badge"
                        [pTooltip]="'Consumed KVA ' + assignment.cabinet.consumption + ' > Contractually allowed KVA ' + assignment.cabinet.powerThreshold">Power cap exceeded</span>
                </td>
                <td>
                  {{ assignment.cabinet.cage }}
                </td>
                <td>
                  <span [pTooltip]="technicalPopService.getCageTooltip(assignment.technicalPop)">{{ assignment.technicalPop }} </span>
                </td>
                <td>
                  {{ assignment.accessCode }}
                </td>
                <td>
                  <span class="coi-pill" [class.coi-status-good]="assignment.isValidCOI" [class.coi-status-bad]="!assignment.isValidCOI">
                    {{ assignment.isValidCOI ? 'Valid' : 'No COI' }}
                  </span>
                </td>
                <td>
                  {{ assignment.workVisitRequest }}
                </td>
                <td class="action-width" *roles="['ROLE_CLIENT']">
                  <button class="btn-new-visit" type="button" [disabled]="!assignment.isValidCOI" [routerLink]="'/work-visit/new/' + assignment.cabinet.id"
                          tooltipPosition="left" [pTooltip]="assignment.isValidCOI ? '': 'Work visits for this service require a valid Certificate of Insurance (COI) to be on file per the Hosting Terms Addendum, Section 3.8 Insurance. Please submit your current COI to the Onboarding Team.'">
                    <i class="fa fa-plus"></i> Create work visit
                  </button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              {{ assignments?.length }} results
            </ng-template>
          </p-table>
        </div>

        <div class="coi-section">
          <div class="symbols-title-row coi-title-row">
            <h3 class="mb-0"><b>Valid Certificates of Insurance</b></h3>
          </div>

          <div *ngIf="loadingCois">
            <p-progressSpinner [style]="{width: '75px', height: '75px'}" animationDuration="1.5s"
                               strokeWidth="3"></p-progressSpinner>
          </div>

          <div *ngIf="!loadingCois">
            <div *ngIf="cois.length === 0" class="coi-empty-state">
              <i class="fa fa-shield"></i>
              <p>There are no valid Certificates of Insurance for this account.</p>
            </div>

            <div class="coi-card" *ngFor="let coi of cois" [class.open]="coi.expanded">
              <div class="coi-summary" (click)="toggleCoi(coi)">
                <i class="fa fa-chevron-right coi-chev"></i>
                <div class="coi-summary-main">
                  <div class="coi-name">{{ coi.name }}</div>
                  <div class="coi-entity">{{ coi.insuredName }}</div>
                </div>
                <span class="coi-pop-tag" *ngIf="coi.hostedPOP">{{ coi.hostedPOP }}</span>
                <span class="coi-spacer"></span>
                <span class="coi-pill" [ngClass]="getCoiStatusClass(coi.status)">{{ coi.status }}</span>
              </div>

              <div class="coi-body" *ngIf="coi.expanded">
                <div class="coi-groups">
                  <div class="coi-group">
                    <h5>General</h5>
                    <div class="coi-row"><span class="k">Subscriber</span><span class="v">{{ coi.subscriber }}</span></div>
                    <div class="coi-row"><span class="k">Certificate holder</span><span class="v">{{ coi.certificateHolder }}</span></div>
                    <div class="coi-row"><span class="k">MB/QD Service</span><span class="v">{{ coi.mckayEntity }}</span></div>
                    <div class="coi-row"><span class="k">Addl gen liab doc</span><span class="v">{{ coi.addlGenLiabDoc }}</span></div>
                    <div class="coi-row"><span class="k">Affiliate confirmation</span><span class="v">{{ coi.affiliateConfirmation ? 'Yes' : 'No' }}</span></div>
                    <div class="coi-row"><span class="k">Affiliate is insured confirmation</span><span class="v">{{ coi.affiliateIsInsuredConfirmation ? 'Yes' : 'No' }}</span></div>
                  </div>
                  <div class="coi-group">
                    <h5>Commercial GL</h5>
                    <div class="coi-row"><span class="k">Each occurrence</span><span class="v">{{ coi.commercialLiability.eachOccurrence | currency: coi.currency }}</span></div>
                    <div class="coi-row"><span class="k">Aggregate</span><span class="v">{{ coi.commercialLiability.aggregate | currency: coi.currency }}</span></div>
                    <div class="coi-row"><span class="k">Effective</span><span class="v">{{ coi.commercialLiability.effectiveDate }}</span></div>
                    <div class="coi-row"><span class="k">Expiration</span><span class="v">{{ coi.commercialLiability.expirationDate }}</span></div>
                  </div>
                  <div class="coi-group">
                    <h5>Umbrella liability</h5>
                    <div class="coi-row"><span class="k">Each occurrence</span><span class="v">{{ coi.umbrellaLiability.eachOccurrence | currency: coi.currency }}</span></div>
                    <div class="coi-row"><span class="k">Aggregate</span><span class="v">{{ coi.umbrellaLiability.aggregate | currency: coi.currency }}</span></div>
                    <div class="coi-row"><span class="k">Effective</span><span class="v">{{ coi.umbrellaLiability.effectiveDate }}</span></div>
                    <div class="coi-row"><span class="k">Expiration</span><span class="v">{{ coi.umbrellaLiability.expirationDate }}</span></div>
                  </div>
                  <div class="coi-group">
                    <h5>Workers comp</h5>
                    <div class="coi-row"><span class="k">Each occurrence</span><span class="v">{{ coi.workersComp.eachOccurrence | currency: coi.currency }}</span></div>
                    <div class="coi-row"><span class="k">Aggregate</span><span class="v">{{ coi.workersComp.aggregate | currency: coi.currency }}</span></div>
                    <div class="coi-row"><span class="k">Effective</span><span class="v">{{ coi.workersComp.effectiveDate }}</span></div>
                    <div class="coi-row"><span class="k">Expiration</span><span class="v">{{ coi.workersComp.expirationDate }}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
